module.exports = __webpack_public_path__ + "img/yrf.fa6381cf.png";